import { Outlet, createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/arc/_sip')({
  component: SipLayout,
});

// Groups all routes that require an active SIP registration.
// Registration is now driven reactively by _syncRegistration() in SipManager,
// which subscribes to operatorStatus and uaTransportStatus. No imperative
// register() / unregister() calls are needed here.
function SipLayout() {
  return <Outlet />;
}
